'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.watchSocketOpened = watchSocketOpened;
exports.watchSubscribe = watchSubscribe;
exports.watchAdd = watchAdd;
exports.watchSetActiveDiscussionWorker = watchSetActiveDiscussionWorker;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _lodash = require('lodash');

var _discussions = require('../api/discussions');

var discussionsApi = _interopRequireWildcard(_discussions);

var _socket = require('../actions/socket');

var socketActions = _interopRequireWildcard(_socket);

var _chats = require('../actions/chats');

var chatsActions = _interopRequireWildcard(_chats);

var _messages = require('../actions/messages');

var messagesActions = _interopRequireWildcard(_messages);

var _discussions2 = require('../actions/discussions');

var discussionsActions = _interopRequireWildcard(_discussions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = [subscribe, subscribeWorker, subscribeChatWorker, subscribeAllWorker, fetchDiscussionsWorker, setActiveDiscussionWorker, watchSocketOpened, watchSubscribe, watchAdd, watchSetActiveDiscussionWorker].map(regeneratorRuntime.mark);

/**
 *	Subscribes to events from the chat having the given id.
 */
function subscribe(id) {
	var actionCreator;
	return regeneratorRuntime.wrap(function subscribe$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					actionCreator = function actionCreator(type, data) {
						switch (type) {
							case 'discussions/create':
								return discussionsActions.addRequest(id, discussionsApi.parse(data));

							default:
								return null;
						}
					};

					_context.next = 3;
					return (0, _effects.put)(socketActions.subscribe('pubsub/chats/' + id, actionCreator));

				case 3:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked[0], this);
}

/**
 *	@see subscribe()
 */
function subscribeWorker(_ref) {
	var id = _ref.payload.id;
	return regeneratorRuntime.wrap(function subscribeWorker$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					_context2.next = 2;
					return subscribe(id);

				case 2:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked[1], this);
}

/**
 *
 */
function subscribeChatWorker(_ref2) {
	var id = _ref2.payload.chat.id;
	return regeneratorRuntime.wrap(function subscribeChatWorker$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _effects.put)(chatsActions.subscribe(id));

				case 2:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked[2], this);
}

/**
 *	@see subscribe()
 */
function subscribeAllWorker() {
	var chats;
	return regeneratorRuntime.wrap(function subscribeAllWorker$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					_context4.next = 2;
					return (0, _effects.select)((0, _lodash.property)('vtChat.chats'));

				case 2:
					chats = _context4.sent;
					_context4.next = 5;
					return (0, _lodash.map)(chats, function (_ref3) {
						var id = _ref3.id;
						return subscribe(id);
					});

				case 5:
				case 'end':
					return _context4.stop();
			}
		}
	}, _marked[3], this);
}

/**
 *
 */
function fetchDiscussionsWorker(_ref4) {
	var id = _ref4.payload.chat.id;
	var actionCreator;
	return regeneratorRuntime.wrap(function fetchDiscussionsWorker$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					actionCreator = function actionCreator(_ref5) {
						var discussions = _ref5.discussions;

						var parsed = discussions.map(discussionsApi.parse);
						return discussionsActions.set(id, parsed);
					};

					_context5.next = 3;
					return (0, _effects.put)(socketActions.call('rpc/chats/' + id + '/discussions/get', actionCreator));

				case 3:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked[4], this);
}

/**
 *
 */
function setActiveDiscussionWorker(_ref6) {
	var _ref6$payload = _ref6.payload;
	var id = _ref6$payload.id;
	var discussionId = _ref6$payload.discussionId;
	return regeneratorRuntime.wrap(function setActiveDiscussionWorker$(_context6) {
		while (1) {
			switch (_context6.prev = _context6.next) {
				case 0:
					_context6.next = 2;
					return (0, _effects.put)(messagesActions.loadMessages(discussionId));

				case 2:
				case 'end':
					return _context6.stop();
			}
		}
	}, _marked[5], this);
}

/**
 *
 */
function watchSocketOpened() {
	return regeneratorRuntime.wrap(function watchSocketOpened$(_context7) {
		while (1) {
			switch (_context7.prev = _context7.next) {
				case 0:
					_context7.next = 2;
					return (0, _reduxSaga.takeEvery)(socketActions.OPENED, subscribeAllWorker);

				case 2:
				case 'end':
					return _context7.stop();
			}
		}
	}, _marked[6], this);
}

/**
 *
 */
function watchSubscribe() {
	return regeneratorRuntime.wrap(function watchSubscribe$(_context8) {
		while (1) {
			switch (_context8.prev = _context8.next) {
				case 0:
					_context8.next = 2;
					return (0, _reduxSaga.takeEvery)(chatsActions.SUBSCRIBE, subscribeWorker);

				case 2:
				case 'end':
					return _context8.stop();
			}
		}
	}, _marked[7], this);
}

/**
 *
 */
function watchAdd() {
	return regeneratorRuntime.wrap(function watchAdd$(_context9) {
		while (1) {
			switch (_context9.prev = _context9.next) {
				case 0:
					_context9.next = 2;
					return [(0, _reduxSaga.takeEvery)(chatsActions.ADD, subscribeChatWorker), (0, _reduxSaga.takeEvery)(chatsActions.ADD, fetchDiscussionsWorker)];

				case 2:
				case 'end':
					return _context9.stop();
			}
		}
	}, _marked[8], this);
}

/**
 *
 */
function watchSetActiveDiscussionWorker() {
	return regeneratorRuntime.wrap(function watchSetActiveDiscussionWorker$(_context10) {
		while (1) {
			switch (_context10.prev = _context10.next) {
				case 0:
					_context10.next = 2;
					return (0, _reduxSaga.takeEvery)(chatsActions.SET_ACTIVE_DISCUSSION, setActiveDiscussionWorker);

				case 2:
				case 'end':
					return _context10.stop();
			}
		}
	}, _marked[9], this);
}